<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  components: {},
  created() {
    this.$http.get("https://randomuser.me/api/").then(response => {
      console.log(response.data);
    });
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/App.vue